import '../scss/collection.scss';

import { collectionMoreInfo } from "../components/collection";

//Collection button
collectionMoreInfo('#collection__button');
